import Loader from './Loader'
import Preloader from './Preloader'

export { Preloader, Loader }
